import { render } from "./Distribution.vue?vue&type=template&id=539b5fb7&scoped=true"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"

import "./Distribution.vue?vue&type=style&index=0&id=539b5fb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539b5fb7"]])

export default __exports__